import { useCookieConsent } from '@packages/utilities';
import { useEffect } from 'react';
import { useTracking } from '../../../hooks';
import { ExternalScriptTestIds } from '../types';

/**
 * This component represents external JavaScript resources to be used on content pages.
 * This component delivers liveshopping content.
 *
 * @param showId String contains show identifier
 * @returns JSX.Element to be placed in PageLayout
 */
export const Liveshopping = ({ showId }: { showId: string }) => {
  const isAllowed: boolean = useCookieConsent('C0004');
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (isAllowed) {
      dispatchGTMEvent({
        event: 'renderLiveshoppingScript',
        liveshoppingShowId: showId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchGTMEvent, isAllowed]);

  return isAllowed ? (
    <div data-testid={ExternalScriptTestIds.LiveshoppingScript} id={showId} />
  ) : (
    <div data-testid={ExternalScriptTestIds.LiveshoppingScriptNotAllowed} />
  );
};
